import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import React from 'react';
import { badgeOptions } from '../../../staticData/common';
import Label from '../../elements/label/Label';
import EditProduct from './EditProduct';
import { formatText } from '../../../utility/utils';

const cardStyle = {
  marginBottom: '16px',
  height: '488px',
};

const ViewProduct = ({
  product,
  fetchProduct,
  setMessage,
  setSnackbarOpen,
}) => {
  const selectedBadge = badgeOptions.find(
    (option) => option.value === product.badge
  );

  return (
    <Card style={cardStyle}>
      <CardHeader
        title="Product info"
        action={
          <div>
            <EditProduct
              product={product}
              fetchData={fetchProduct}
              setMessage={setMessage}
              setSnackbarOpen={setSnackbarOpen}
            />
          </div>
        }
        sx={{ paddingBottom: 0 }}
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              style={{
                fontWeight: 'bold',
                marginRight: '8px',
                display: 'inline',
              }}>
              Title:
            </Typography>
            <Typography variant="body1" style={{ display: 'inline' }}>
              {product.title}
            </Typography>
          </Grid>
          {product.brand && (
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 'bold',
                  marginRight: '8px',
                  display: 'inline',
                }}>
                Brand:
              </Typography>
              <Typography variant="body1" style={{ display: 'inline' }}>
                {product.brand}
              </Typography>
            </Grid>
          )}
          {product.description && (
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 'bold',
                  marginRight: '8px',
                  display: 'inline',
                }}>
                Description:
              </Typography>
              <Typography
                variant="body1"
                style={{
                  display: '-webkit-box',
                  WebkitLineClamp: 4,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>
                {formatText(product.description)}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              style={{
                fontWeight: 'bold',
                marginRight: '8px',
                display: 'inline',
              }}>
              Price:
            </Typography>
            <Typography variant="body1" style={{ display: 'inline' }}>
              $
              {parseFloat(product.price).toLocaleString('en-US', {
                maximumFractionDigits: 2,
              })}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              style={{
                fontWeight: 'bold',
                marginRight: '8px',
                display: 'inline',
              }}>
              Status:
            </Typography>
            <Label color={product.status === 'active' ? 'success' : 'default'}>
              {product.status}
            </Label>
          </Grid>
          <Grid item xs={12}>
            {product.category_data && product.category_data.name && (
              <>
                <Typography
                  variant="subtitle1"
                  style={{
                    fontWeight: 'bold',
                    marginRight: '8px',
                    display: 'inline',
                  }}>
                  Category:
                </Typography>
                <Typography variant="body1" style={{ display: 'inline' }}>
                  {product.category_data.name}
                </Typography>
              </>
            )}
          </Grid>
          {product.badge && (
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                style={{
                  fontWeight: 'bold',
                  marginRight: '8px',
                  display: 'inline',
                }}>
                Badge:
              </Typography>
              <Typography variant="body1" style={{ display: 'inline' }}>
                {selectedBadge ? selectedBadge.label : 'None'}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ViewProduct;
